/**
 * DevExtreme (ui/widget/child_default_template.js)
 * Version: 16.2.5
 * Build date: Mon Feb 27 2017
 *
 * Copyright (c) 2012 - 2017 Developer Express Inc. ALL RIGHTS RESERVED
 * EULA: https://www.devexpress.com/Support/EULAs/DevExtreme.xml
 */
"use strict";
var TemplateBase = require("./ui.template_base");
module.exports = TemplateBase.inherit({
    ctor: function(name) {
        this.name = name
    }
});



//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/devextreme/ui/widget/child_default_template.js
// module id = ../../../../devextreme/ui/widget/child_default_template.js
// module chunks = 3